// Create jQuery slideToggle in Vanilla JS
// to see filter options in archives templates
(function() {
    var block, i, j, len, len1, ref, ref1, slideToggler, trigger,
        indexOf = [].indexOf;

    slideToggler = class slideToggler {
        constructor(el1) {
            this.getHeight = this.getHeight.bind(this);
            this.toggle = this.toggle.bind(this);
            this.el = el1;
            if (!this.el) {
                return;
            }
            window.addEventListener('resize', this.getHeight);
        }

        getHeight() {
            var clone;
            clone = this.el.cloneNode(true);
            clone.style.cssText = 'visibility: hidden; display: block; margin: -999px 0';
            this.height = (this.el.parentNode.appendChild(clone)).clientHeight;
            this.el.parentNode.removeChild(clone);
            return this.height;
        }

        toggle(time) {
            var currHeight, disp, el, end, init, repeat, start;
            this.getHeight();
            time || (time = this.height / 3 + 150);
            currHeight = this.el.clientHeight * (getComputedStyle(this.el).display !== 'none');
            [start, end] = currHeight > this.height / 2 ? [this.height, 0] : [0, this.height];
            disp = end - start;
            el = this.el;
            this.el.classList[end === 0 ? 'remove' : 'add']('open');
            this.el.style.cssText = "overflow: hidden; display: block;";
            init = (new Date).getTime();
            repeat = function() {
                var instance, ref, repeatLoop, step;
                instance = (new Date).getTime() - init;
                step = start + disp * instance / time;
                if (instance <= time) {
                    el.style.height = step + 'px'; // if Math.floor(step) in [start..end]
                } else {
                    el.style.cssText = `display: ${(end === 0 ? 'none' : 'block')}`;
                }
                repeatLoop = requestAnimationFrame(repeat);
                if (ref = Math.floor(step), indexOf.call((function() {
                    var results = [];
                    for (var i = start; start <= end ? i <= end : i >= end; start <= end ? i++ : i--){ results.push(i); }
                    return results;
                }).apply(this), ref) < 0) {
                    return cancelAnimationFrame(repeatLoop);
                }
            };
            return repeat();
        }

    };

    ref = document.querySelectorAll('.filter__options');
    for (i = 0, len = ref.length; i < len; i++) {
        block = ref[i];
        block.toggler = new slideToggler(block);
    }

    ref1 = document.querySelectorAll('.button--toggler');
    for (j = 0, len1 = ref1.length; j < len1; j++) {
        trigger = ref1[j];
        trigger.addEventListener('click', function() {
            var ref2;
            return (ref2 = this.parentNode.querySelector('.filter__options').toggler) != null ? ref2.toggle() : void 0;
        });
    }
}).call(this);


// Change toggler text on click
var toClick = document.querySelectorAll(".button--toggler")[0];
var textToSwap = document.querySelectorAll(".text-to-swap")[0];

if (typeof(toClick) !== 'undefined') {
    toClick.addEventListener('click', function () {
        if (textToSwap.getAttribute("data-text-swap") == textToSwap.innerHTML) {
            textToSwap.innerHTML = textToSwap.getAttribute("data-text-original");
        } else {
            textToSwap.setAttribute("data-text-original", textToSwap.innerHTML);
            textToSwap.innerHTML = textToSwap.getAttribute("data-text-swap");
        }
    }, false);

// Change toggle class on click
    function classToggle() {
        this.classList.toggle('is-closed');
        this.classList.toggle('is-open');
    }

    document.querySelector('.button--toggler').addEventListener('click', classToggle);

    function filterClassToggle() {
        let selectBox = document.querySelector('.select-box.is-open');
        if(selectBox !== null && selectBox !== this.closest('.select-box')) {
            selectBox.classList.remove('is-open')
            selectBox.classList.add('is-closed');
        }
        this.closest('.select-box').classList.toggle('is-closed');
        this.closest('.select-box').classList.toggle('is-open');
    }

    let filters = document.querySelectorAll('.filter__input-container');

    filters.forEach((filter) => {
        filter.addEventListener('click', filterClassToggle);
    })

    // Remove open class filters on click outside
    document.addEventListener('click', function(event){
        let selectBox = document.querySelector('.select-box.is-open');
        if(selectBox !== null){
            let selectBoxContent = selectBox.querySelectorAll('*');
            if ((-1 >= Array.from(selectBoxContent).indexOf(event.target))){
                selectBox.classList.remove('is-open');
                selectBox.classList.add('is-closed');
            }
        }
    })
}
